import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import MiniHero from "@modules/HeroModule/MiniHero"
import { useBreakpoints } from "@hooks/useBreakpoints"

const Hero = () => {
  const { t } = useTranslation()

  const params = {
    title: t("CaseStudyCompetitive_Header"),
    titleClass:
      "md:!font-medium xl:!text-[48px] xl:!leading-normal desk:!text-[32px] xl:!mb-4",
    subheading: t("CaseStudyCompetitive_Subheader1"),
    image: "competitive-hero.png",
    className:
      "flex flex-col md:flex-row md:items-end md:h-90 desk:h-[60vh] xl:h-screen md:py-10 md:px-11 xl:px-25 xl:py-20 md:relative max-h-[700px]",
    contentClassName: "max-w-screen-fhd",
    headerClass: "md:max-w-[390px] desk:max-w-[60%]  xl:max-w-[844px] ",
    subheadingClassName: "text-20   desk:!text-[28px] xl:!text-[36px]",

    showGradientLayer: true,
    gradientStyle: {
      background:
        "linear-gradient(5deg, rgba(21, 17, 36, 0.71) 37.19%, rgba(21, 17, 36, 0.00) 75%)",
    },
    hideButtonsOnMobile: true,
    gradientClassName: "hidden md:block",
  }
  return <MiniHero {...params} />
}
export default Hero
